module.exports = __webpack_public_path__ + "img/26.14c30302.svg";